import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    async DatosDetalle(vm){
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("aiclave", datos.aiclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/DetalleGeneralReporte`, datosReporte).then(response => response.data);
    },
    async Telefonos(vm){
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/DetalleGeneralTelefonos`, datosReporte).then(response => response.data);

    },
    async LlamadaIVRServ(vm,destino) {
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("destino", destino);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/IVR`, datosReporte).then(response => response.data);

    },

    obtenerPermisoTelefonos(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ObtenerPermisoTelefonos`).then(response => response.data)

    },

    obtenerPermisoEdicion(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ObtenerPermisoEdicion`).then(response => response.data)

    },

    async actualizarEmail(vm) {
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("svemail", vm.svemail);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ActualizarEmail`, formData).then(response => response.data)


    },

    async obtenerActores(vm) {
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("aiclave", datos.aiclave);
        vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ObtenerActores`, formData).then(response => {
          
            vm.actores.opcionesActores = response.data;

        })
    },

    obtenerTiposTelf(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ObtenerTiposTelf`).then(response => {
            
            vm.tipotelf.opcionestipotelf = response.data;

        })
    },

    async altaContacto(vm) {
       
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("staid", vm.actores.staid.staid);
        formData.append("sttid", vm.tipotelf.sttid.sttid);
        formData.append("stprefijo", vm.prefijo);
        formData.append("stnumero", vm.numtelf2);
        formData.append("stverificado", 0);
        formData.append("stpais", vm.pais);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/AltaContacto`, formData).then(response => response.data)

    },

    async eliminarContacto(vm,item) {
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("staid", item.staid);
        formData.append("sttid", item.sttid);
        formData.append("stid", item.stid);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/EliminarContacto`, formData).then(response => response.data)

    },


    async actualizarContacto(vm,item) {
        
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("stid", item.stid);
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("staid", vm.actores.staid.staid);
        formData.append("sttid", vm.tipotelf.sttid.sttid);
        formData.append("stprefijo", vm.prefijo);
        formData.append("stnumero", vm.numtelf2);
        formData.append("stverificado", 0);
        formData.append("stpais", vm.pais);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ActualizarContacto`, formData).then(response => response.data)


    },
    obtenerPermisoIVR(vm) {
        var permiso = new FormData();
        permiso.append("permiso", 130);
        return vm.axios.post(`${vm.domain.domainNameForApi}DetalleReporte/ObtenerPermisoIVR`,permiso).then(response => response.data)
    },
}